module.exports = __webpack_public_path__ + "static/img/iAdapter@2x.064f8b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/iAdapter@2x.jpg
// module id = 463
// module chunks = 0